import { RxArrowRight } from 'react-icons/rx';

interface BannerProps {
  title: string;
  description: string | JSX.Element;
  onClick?: () => void;
  className?: string;
}

function Banner({ title, description, onClick, className }: BannerProps) {
  return (
    <div
      className={`absolute w-full border-b border-gray-400 overflow-hidden bg-[#002327] py-[8px] min-h-[42px] pt-[13px] ${className}`}
    >
      <div className='mx-auto px-4 md:container flex items-center gap-x-2 md:gap-x-6'>
        <p className='min-h-[19.3px] mt-[1px] text-sm/6 text-white line-clamp-2 md:line-clamp-1 leading-4 max-w-[calc(100%-84px)]'>
          <strong className='font-bold'>{title}</strong>
          <span className='px-2'>&middot;</span>

          {onClick ? (
            <span onClick={onClick} className='inline hover:underline cursor-pointer'>
              {description}
            </span>
          ) : (
            description
          )}
        </p>

        {onClick && (
          <button onClick={onClick} className='min-w-[92px] mb-[2px] ml-auto hover:opacity-75 text-[#7ad817] text-sm'>
            Read More <RxArrowRight className='inline size-5 mb-[1px]' />
          </button>
        )}
      </div>
    </div>
  );
}

export default Banner;
